import { Component, Input, ChangeDetectionStrategy, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { HttpHelper, DialogHelper } from 'nglhelper';
import { trigger, transition, style, animate } from '@angular/animations';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    templateUrl: './tablestatus.component.html',
    selector: 'table-status',
    styleUrls: ['./tablestatus.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('flyIn', [
            transition(':enter', [
                style({ height: 0 }),
                animate(250, style({ height: '*' }))
            ]),
            transition(':leave', [
                style({ height: '*' }),
                animate(250, style({ height: 0 }))
            ])
        ])
    ]
})
export class TableStatusComponent implements OnInit, OnDestroy {

    constructor(private httpLoader: HttpHelper, private cdr: ChangeDetectorRef) {
    }

    _loaderName;

    ErrorMessage: any;
    IsLoading = false;
    destroy$ = new Subject();

    @Input()
    set loader(val) {
        this._loaderName = val;
    }

    ngOnInit() {
        if (this._loaderName) {
            this.httpLoader
                .LoaderState(this._loaderName)
                .pipe(takeUntil(this.destroy$))
                .subscribe((res) => {
                    this.IsLoading = res;
                    this.cdr.markForCheck();
                });

            this.httpLoader.ErrorState(this._loaderName)
                .pipe(takeUntil(this.destroy$))
                .subscribe((res) => {
                    this.ErrorMessage = DialogHelper.GetFriendlyError(res);
                    this.cdr.markForCheck();
                });
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
    }
}
